import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import styles from './GroupUserTable.module.css'; // 원하는 스타일 적용
import { Today } from '@mui/icons-material';

export const ADMINROLE = {
  SYS_ADMIN: 'SYS_ADMIN',
  ADMIN_USER: 'ADMIN_USER'
}

const ServiceUserTable = ({ users, onDeleteUsers, onAddUser, detailUser, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow }) => {
  const [selected, setSelected] = useState([]);
  const [sortField, setSortField] = useState('userId');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchType, setSearchType] = useState("userId");
  // const {openModal} = useContext(ModalContext);

  const [userInfo, setUserInfo] = useState({
    userId: sessionStorage.getItem("userId"),
    userName: sessionStorage.getItem("userName"),
    role: sessionStorage.getItem("role")
  })

  // 정렬 처리
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedUsers = [...users].sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];
    // 날짜 비교
    if (sortField === "createdDate" || sortField === "lastConnectionDate") {
      valA = Number(valA) || 0;
      valB = Number(valB) || 0;
    }
    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  const currentUserId = Number(sessionStorage.getItem("id"));
  // 체크박스 관련
  // const isAllSelected = selected.length === users.length && users.length > 0;
  const selectableIds = users.map(u => u.id).filter(id => id !== currentUserId);
  const isAllSelected = selectableIds.every(id => selected.includes(id));


  const handleSelectAll = () => {
    // setSelected(isAllSelected ? [] : users.map(u => u.id));
    // const selectableIds = users.map(u => u.id).filter(id => id !== currentUserId);
    setSelected(isAllSelected ? [] : selectableIds);
  };

  const handleSelectRow = (id) => {
    // setSelected(selected.includes(id)
    //   ? selected.filter(i => i !== id)
    //   : [...selected, id]);

    // if (id === currentUserId) return; // 현재 로그인 ID는 선택 불가
    // setSelected(selected.includes(id)
    //   ? selected.filter(i => i !== id)
    //   : [...selected, id]);
    if (id === currentUserId) return; // 제외
    setSelected(selected.includes(id)
      ? selected.filter(i => i !== id)
      : [...selected, id]);
  };

  // 삭제
  const handleDeleteSelected = () => {
    if (selected.length > 0) {
      onDeleteUsers(selected); // 리스트로 넘김
      setSelected([]);
    }
  };

  const handleSingleDelete = (id) => {
    onDeleteUsers([id]);
    setSelected(selected.filter(i => i !== id));
  };

  const transStatusView = (status) => {
    switch (status) {
      case true:
        return <span className={styles.badge} style={{ backgroundColor: '#4CAF50' }}>활성화</span>;
      default:
        return <span className={styles.badge} style={{ backgroundColor: '#F44336' }}>비활성화</span>;
    }
  };

  const transRoleView = (role) => {
    switch (role) {
      case ADMINROLE.SYS_ADMIN:
        return '시스템 관리자';
      case ADMINROLE.ADMIN_USER:
        return '계정 관리자';
      default:
        return '오류';
    }
  };

  const handleStatusChange = (e) => {
    setSearchType(e.target.value);
  };

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
        <div className={styles.actionBar}>
          <select name={"status"}
            className={styles.rightCont__cont__select} value={searchType}
            style={{ appearance: "auto", padding: '10px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
            onChange={handleStatusChange}>
            <option value={"userId"} defaultValue={true}>아이디</option>
            <option value={"groupId"}>그룹명</option>
            {/* <option value={"status"}>상태</option> */}
          </select>
          <input
            className={styles.rightCont__cont__search}
            type="text"
            placeholder="아이디, 사용자 검색"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              padding: '10px 20px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
          <button
            onClick={() => onSearch(searchType, searchValue)}
            className={styles.addBtn}
          >
            검  색
          </button>
        </div>
        {userInfo.role == 'SYS_ADMIN' && (
          <>
            {/* 오른쪽: 버튼 묶음 */}
            <div className={styles.actionBar}>
              <button
                onClick={handleDeleteSelected}
                className={styles.deleteBtn}
                disabled={selected.length === 0}
              >
                제  거
              </button>
              <button
                onClick={onAddUser}
                className={styles.addBtn}
              >
                추  가
              </button>
            </div>
          </>
        )}
      </div>
      {/* <div className={styles.actionBar}> */}
      {/* {groupId !== "0" && ( */}
      {/* <>
        <button onClick={handleDeleteSelected} className={styles.deleteBtn} disabled={selected.length === 0}>제거</button>
        <button onClick={onAddUser} className={styles.addBtn}> 유저 추가 </button>
      </> */}
      {/* )} */}
      {/* </div> */}
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.checkboxCell}>
              {/* <input
                type="checkbox"
                className={styles.userCheckbox}
                checked={isAllSelected}
                onChange={handleSelectAll}
              /> */}
              <input
                type="checkbox"
                className={styles.userCheckbox}
                checked={isAllSelected}
                ref={el => {
                  if (el) {
                    el.indeterminate = selected.length > 0 && !isAllSelected;
                  }
                }}
                onChange={handleSelectAll}
              />
            </th>
            <th className={styles.idCol} onClick={() => handleSort('email')} style={{ cursor: 'pointer' }}>
              아이디 {sortField === 'userId' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('groupId')} style={{ cursor: 'pointer' }}>
                그룹 {sortField === 'groupId' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            <th className={styles.idCol} onClick={() => handleSort('role')} style={{ cursor: 'pointer' }}>
              권한 {sortField === 'role' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            <th className={styles.idCol} onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
              상태 {sortField === 'status' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {/* <th className={styles.authCol}>권한</th>
        <th className={styles.removeCol}>그룹 제거</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user) => (
            // <tr key={user.id} className={styles.tableRow} onClick={() => handleRowClick(user.id)}  style={{ cursor: "pointer" }}>
            <tr key={user.id} className={styles.tableRow} onClick={() => detailUser(user.id)} style={{ cursor: "pointer" }}>
              <td className={styles.checkboxCell}>
                <input
                  className={styles.userCheckbox}
                  type="checkbox"
                  checked={selected.includes(user.id)}
                  disabled={user.id === currentUserId}
                  onClick={(e) => { e.stopPropagation() }}
                  onChange={(e) => {
                    handleSelectRow(user.id)
                  }}
                />
              </td>
              {/* <td className={styles.idCol}>{products[user.product]?.name}</td>
          {!isMobileWindow && (
            <td className={styles.idCol}>
              {
                products[user.product]?.plans.find(p => String(p.id) === String(user.plan))?.plan || '알 수 없음'
              }
              </td>
          )} */}
              <td className={styles.idCol}>{user.userId}</td>
              {/* <td className={styles.idCol}>{user.password}</td> */}
              {!isMobileWindow && (
                <td className={styles.idCol}>{user.groupId ? user.groupId : '-'}</td>
              )}
              <td className={styles.idCol}>{transRoleView(user.role)}</td>
              <td className={styles.idCol}>{transStatusView(user.status)}</td>
            </tr>
          ))}
          {users.length === 0 && (
            <tr>
              {!isMobileWindow ?
                (<td colSpan={5} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>) :
                (<td colSpan={4} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>)
              }
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.actionBar} style={{ marginTop: "8px" }}>
        <>
          {totalCount > 0 && (
            <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
          )}
          <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
          <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
        </>
      </div>
    </div>
  );
};

export default ServiceUserTable;
